// Department constants for complaint system
export const DEPARTMENTS = [
  { id: "purchasing", nameKey: "department_purchasing" },
  { id: "sales", nameKey: "department_sales" },
  { id: "logistics", nameKey: "department_logistics" },
  { id: "quality", nameKey: "department_quality" },
  { id: "production", nameKey: "department_production" },
  { id: "administration", nameKey: "department_administration" },
  { id: "customer_service", nameKey: "department_customer_service" },
  { id: "transport", nameKey: "department_transport" },
];

// Complaint reasons
export const COMPLAINT_REASONS = [
  { id: "poor_quality", labelKey: "poor_quality" },
  { id: "not_delivered", labelKey: "not_delivered" },
  { id: "not_ordered", labelKey: "not_ordered" },
  { id: "foreign_object", labelKey: "foreign_object" },
  { id: "wrong_labeling", labelKey: "wrong_labeling" },
  { id: "administrative", labelKey: "administrative" },
  { id: "other", labelKey: "other_specify" },
];
